import React from 'react';
import { LegalFooter } from './LegalFooter';
import { useT } from '../lib/i18n';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Contact() {
  const { t } = useT();
  return (
    <div className="grain min-h-screen flex flex-col bg-[#050510] text-white">
      <div className="flex-1 w-full max-w-4xl mx-auto px-6 py-12 relative">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A0A0B0] hover:text-white transition-colors mb-8 font-bold text-sm bg-white/5 px-4 py-2 rounded-xl hover:bg-white/10">
          <ArrowLeft size={18} /> {t("back_home")}
        </Link>
        <h1 className="font-display text-4xl font-black text-[#00FF66] mb-8">{t("contact_title")}</h1>
        <div className="space-y-6 text-[#A0A0B0] leading-relaxed text-sm sm:text-base">
           <p>{t("contact_p1")}</p>
           <p>{t("contact_p2")}</p>
           
           <div className="bg-[#12121A] border-2 border-white/10 p-6 rounded-2xl mt-8">
             <h3 className="text-white font-bold mb-2">{t("contact_email")}</h3>
             {/* Pamiętaj o podmianie na Twój prawdziwy adres e-mail! */}
             <p className="text-[#00FFFF] font-mono2 text-lg">kontakt@twojadomena.pl</p> 
           </div>
        </div>
      </div>
      <LegalFooter screen="KONTAKT" />
    </div>
  );
}